/** Route the customer contact tabs are relative to (admin and portal Contacts). */
export const CUSTOMER_CONTACTS_ROUTE = 'contact/list';

/** The customer contact tabs. Shared by the page and the hover sub-navigation. */
export const CUSTOMER_CONTACT_TABS: { linkText: string; translationKey: string }[] = [
  { linkText: 'contact', translationKey: 'CUSTOMER_CONTACTS' },
  { linkText: 'login', translationKey: 'CUSTOMER_CONTACTS_WITHLOGIN' }
];
